"use strict";

var migrateReportDinamicEmail = require("./migrateReportDinamicEmail");

module.exports = [
    "$uibModalInstance",
    "$uibModal",
    "BuilderDataService",
    "ReportConfig",
    "reportConfig",
    "toast",
    "$translate",
    "dialog",
    "$timeout",
    "$sce",
    function (
        $uibModalInstance,
        $uibModal,
        BuilderDataService,
        ReportConfig,
        reportConfig,
        toast,
        $translate,
        dialog,
        $timeout,
        $sce
    ) {
        var _this = this;
        this.taskValidated = false;
        this.error = "";
        this.migrate = false;

        _this.triggerList = [
            {
                id: "new_record",
                // name: "Nuevo Registro",
                name: $translate.instant(
                    "DASHBOARD.DASH_FORM.ACTIONS.TRIGGER_LIST.NEW_RECORD"
                ),
            },
            {
                id: "validate",
                // name: "Validación OK / Rechazada",
                name: $translate.instant(
                    "DASHBOARD.DASH_FORM.ACTIONS.TRIGGER_LIST.VALIDATE"
                ),
            },
            {
                id: "validate_ok",
                // name: "Validacion OK",
                name: $translate.instant(
                    "DASHBOARD.DASH_FORM.ACTIONS.TRIGGER_LIST.VALIDATE_OK"
                ),
            },
            {
                id: "validate_reject",
                // name: "Validación Rechazada",
                name: $translate.instant(
                    "DASHBOARD.DASH_FORM.ACTIONS.TRIGGER_LIST.VALIDATE_REJECT"
                ),
            },
            {
                id: "del_record",
                // name: "Eliminación de un Registro",
                name: $translate.instant(
                    "DASHBOARD.DASH_FORM.ACTIONS.TRIGGER_LIST.DEL_RECORD"
                ),
            },
        ];

        _this.actionList = [
            {
                id: "email",
                // name: "Envío de Reportes (Emails/WhatsApp)",
                name: $translate.instant(
                    "DASHBOARD.DASH_FORM.ACTIONS.ACTIONS_LIST.EMAIL"
                ),
                // disable: true,
                disable: false,
            },
            {
                id: "webhook",
                // name: "Activación de WebHook",
                name: $translate.instant(
                    "DASHBOARD.DASH_FORM.ACTIONS.ACTIONS_LIST.WEBHOOK"
                ),
                // disable: true,
                disable: false,
            },
            {
                id: "certifyPdf",
                // name: "Certificar Transacción en Blockchain",
                name: $translate.instant(
                    "DASHBOARD.DASH_FORM.ACTIONS.ACTIONS_LIST.CERTIFY_PDF"
                ),
                // disable: true,
                disable: false,
            },
            {
                id: "task",
                // name: "Generación de Tarea (Solicita completar formulario)",
                name: $translate.instant(
                    "DASHBOARD.DASH_FORM.ACTIONS.ACTIONS_LIST.TASK"
                ),
                disable: true,
                // disable: false,
            },
        ];

        _this.reportList = [
            {
                id: "none",
                // name: "No enviar",
                name: $translate.instant(
                    "DASHBOARD.DASH_FORM.ACTIONS.REPORT_LIST.NONE"
                ),
            },
            {
                id: "pdf_attachment",
                // name: "Adjunto PDF",
                name: $translate.instant(
                    "DASHBOARD.DASH_FORM.ACTIONS.REPORT_LIST.PDF_ATTACHMENT"
                ),
            },            
            {
                id: "html_attachment",
                // name: "HTML Adjunto",
                name: $translate.instant(
                    "DASHBOARD.DASH_FORM.ACTIONS.REPORT_LIST.HTML_ATTACHMENT"
                ),
            },
            {
                id: "html_embedded",
                // name: "HTML Incrustado",
                name: $translate.instant(
                    "DASHBOARD.DASH_FORM.ACTIONS.REPORT_LIST.HTML_EMBEDDED"
                ),
            },
        ];

        if (reportConfig.actions === undefined || !angular.isArray(reportConfig.actions)) {
            _this.actions = [];
        } else {
            _this.actions = [...reportConfig.actions];
        }

        // Normalize "inactive" flag: anything that is not strictly true means active.
        _this.actions.forEach(function (action) {
            action.inactive = action.inactive === true;
        });

        _this.element = reportConfig;

        if (_this.element.reportDinamicEmail == undefined) {
            _this.element.reportDinamicEmail = [];
        }

        this.touchedFields = []; // Initialize array to track touched fields

        // Function to mark a field as touched
        this.markTouched = function (index, fieldName) {
            if (!this.touchedFields[index]) {
                this.touchedFields[index] = {};
            }
            this.touchedFields[index][fieldName] = true; // Mark the field as touched
        };

        _this.form = BuilderDataService.getForm();

        this.addConditionInAction = function (action, index) {
            let item = {
                conditions: [
                    {
                        type: "field",
                        fieldId: "",
                        value: "",
                        operator: "", //>,< ,>= >=, !=
                    },
                ],
            };

            if (_this.actions[index].reportDinamicCondition) {
                _this.actions[index].reportDinamicCondition.push(item);
            } else {
                _this.actions[index].reportDinamicCondition = [item];
            }
        };

        this.areValid = function (conditions) {
            let invalid = conditions.filter(function (con) {
                return !con.valid;
            });

            if (invalid && invalid.length > 0) {
                return false;
            } else {
                return true;
            }
        };

        this.cloneAction = (index) => {
            // console.log('_this.actions[index]', _this.actions[index]);
            let clonedAction = JSON.parse(JSON.stringify(_this.actions[index]));
            delete clonedAction.$$hashKey;
            // console.log('clonedAction', clonedAction)
            _this.actions.splice(index + 1, 0, clonedAction);
            // console.log('_this.actions', _this.actions);
        }

        this.validateFields = function () {
            // Init errors array
            let errors = [];
            _this.error = "";

            for (let i = 0; i < _this.actions.length; i++) {
                let action = _this.actions[i];

                // Validate general fields
                if (!action.name) {
                    errors.push(
                        `"${$translate.instant(
                            "DASHBOARD.DASH_FORM.ACTIONS.ACTION_TITLE"
                        )} ${i + 1}": "${$translate.instant(
                            "DASHBOARD.DASH_FORM.ACTIONS.FIELDS.NAME"
                        )}" ${$translate.instant(
                            "DASHBOARD.DASH_FORM.ACTIONS.ERROR_REQUIRED_FIELD"
                        )}`
                    );
                }
                // if (!action.description) {
                //     errors.push(
                //         `"${$translate.instant(
                //             "DASHBOARD.DASH_FORM.ACTIONS.ACTION_TITLE"
                //         )} ${i + 1}": "${$translate.instant(
                //             "DASHBOARD.DASH_FORM.ACTIONS.FIELDS.DESCRIP"
                //         )}" ${$translate.instant(
                //             "DASHBOARD.DASH_FORM.ACTIONS.ERROR_REQUIRED_FIELD"
                //         )}`
                //     );
                // }
                if (!action.start) {
                    errors.push(
                        `"${$translate.instant(
                            "DASHBOARD.DASH_FORM.ACTIONS.ACTION_TITLE"
                        )} ${i + 1}": "${$translate.instant(
                            "DASHBOARD.DASH_FORM.ACTIONS.FIELDS.INIT_WHEN"
                        )}" ${$translate.instant(
                            "DASHBOARD.DASH_FORM.ACTIONS.ERROR_REQUIRED_FIELD"
                        )}`
                    );
                }
                if (!this.areValid(action.reportDinamicCondition)) {
                    errors.push(
                        `"${$translate.instant(
                            "DASHBOARD.DASH_FORM.ACTIONS.ACTION_TITLE"
                        )} ${i + 1}": "${$translate.instant(
                            "DASHBOARD.DASH_FORM.ACTIONS.FIELDS.DATA_MATCH"
                        )}": ${$translate.instant(
                            "DASHBOARD.DASH_FORM.ACTIONS.ERROR_REQUIRED_CONDITIONS"
                        )}`
                    );
                }
                if (!action.action) {
                    errors.push(
                        `"${$translate.instant(
                            "DASHBOARD.DASH_FORM.ACTIONS.ACTION_TITLE"
                        )} ${i + 1}": "${$translate.instant(
                            "DASHBOARD.DASH_FORM.ACTIONS.FIELDS.ACTION_TODO"
                        )}" ${$translate.instant(
                            "DASHBOARD.DASH_FORM.ACTIONS.ERROR_REQUIRED_FIELD"
                        )}`
                    );
                }

                // Validate fields for action type
                switch (action.action) {
                    case "email":
                        if (action.actionData.pdf === "") {
                            errors.push(
                                `"${$translate.instant(
                                    "DASHBOARD.DASH_FORM.ACTIONS.ACTION_TITLE"
                                )} ${i + 1}": "${$translate.instant(
                                    "DASHBOARD.DASH_FORM.ACTIONS.ACTIONS_LIST.EMAIL"
                                )}": "${$translate.instant(
                                    "DASHBOARD.DASH_FORM.ACTIONS.FIELDS.ACTION_EMAIL.PDF_REPORT"
                                )}" ${$translate.instant(
                                    "DASHBOARD.DASH_FORM.ACTIONS.ERROR_REQUIRED_FIELD"
                                )}`
                            );
                        }
                        if (action.actionData.options.length === 0) {
                            errors.push(
                                `"${$translate.instant(
                                    "DASHBOARD.DASH_FORM.ACTIONS.ACTION_TITLE"
                                )} ${i + 1}":  "${$translate.instant(
                                    "DASHBOARD.DASH_FORM.ACTIONS.ACTIONS_LIST.EMAIL"
                                )}": "${$translate.instant(
                                    "DASHBOARD.DASH_FORM.ACTIONS.FIELDS.ACTION_EMAIL.RECIPIENTS"
                                )}" ${$translate.instant(
                                    "DASHBOARD.DASH_FORM.ACTIONS.ERROR_REQUIRED_FIELD"
                                )}`
                            );
                        }
                        break;

                    case "webhook":
                        if (
                            action.actionData.connection.method === null ||
                            action.actionData.connection.method === ""
                        ) {
                            errors.push(
                                `"${$translate.instant(
                                    "DASHBOARD.DASH_FORM.ACTIONS.ACTION_TITLE"
                                )} ${i + 1}": "${$translate.instant(
                                    "DASHBOARD.DASH_FORM.ACTIONS.ACTIONS_LIST.WEBHOOK"
                                )}": "${$translate.instant(
                                    "DASHBOARD.DASH_TASKS.FIELDS.METHOD"
                                )}" ${$translate.instant(
                                    "DASHBOARD.DASH_FORM.ACTIONS.ERROR_REQUIRED_FIELD"
                                )}`
                            );
                        }
                        if (
                            action.actionData.connection.url === null ||
                            action.actionData.connection.url === ""
                        ) {
                            errors.push(
                                `"${$translate.instant(
                                    "DASHBOARD.DASH_FORM.ACTIONS.ACTION_TITLE"
                                )} ${i + 1}": "${$translate.instant(
                                    "DASHBOARD.DASH_FORM.ACTIONS.ACTIONS_LIST.WEBHOOK"
                                )}": "${$translate.instant(
                                    "DASHBOARD.DASH_TASKS.FIELDS.URL"
                                )}" ${$translate.instant(
                                    "DASHBOARD.DASH_FORM.ACTIONS.ERROR_REQUIRED_FIELD"
                                )}`
                            );
                        }
                        if (angular.isArray(action.actionData.connection.queryParams)) {
                            for (let j = 0; j < action.actionData.connection.queryParams.length; j++) {
                                if (action.actionData.connection.queryParams[j].key === '') {
                                    errors.push(
                                        `"${$translate.instant(
                                            "DASHBOARD.DASH_FORM.ACTIONS.ACTION_TITLE"
                                        )} ${i + 1}": "${$translate.instant(
                                            "DASHBOARD.DASH_FORM.ACTIONS.ACTIONS_LIST.WEBHOOK"
                                        )}": "${$translate.instant(
                                            "DASHBOARD.DASH_TASKS.FIELDS.QUERY_PARAMS"
                                        )}": "Query"
                                        ${$translate.instant(
                                            "DASHBOARD.DASH_FORM.ACTIONS.ERROR_REQUIRED_FIELD"
                                        )}`
                                    );
                                }
                                if (action.actionData.connection.queryParams[j].value === '') {
                                    errors.push(
                                        `"${$translate.instant(
                                            "DASHBOARD.DASH_FORM.ACTIONS.ACTION_TITLE"
                                        )} ${i + 1}": "${$translate.instant(
                                            "DASHBOARD.DASH_FORM.ACTIONS.ACTIONS_LIST.WEBHOOK"
                                        )}": "${$translate.instant(
                                            "DASHBOARD.DASH_TASKS.FIELDS.QUERY_PARAMS"
                                        )}": "
                                        ${$translate.instant(
                                            "DASHBOARD.DASH_INTEG.FIELDS.PH_VALUE"
                                        )}
                                        " ${$translate.instant(
                                            "DASHBOARD.DASH_FORM.ACTIONS.ERROR_REQUIRED_FIELD"
                                        )}`
                                    );
                                }
                            
                            }
                            for (let j = 0; j < action.actionData.connection.headers.length; j++) {
                                if (action.actionData.connection.headers[j].key === '') {
                                    errors.push(
                                        `"${$translate.instant(
                                            "DASHBOARD.DASH_FORM.ACTIONS.ACTION_TITLE"
                                        )} ${i + 1}": "${$translate.instant(
                                            "DASHBOARD.DASH_FORM.ACTIONS.ACTIONS_LIST.WEBHOOK"
                                        )}": "${$translate.instant(
                                            "DASHBOARD.DASH_TASKS.FIELDS.HEADERS"
                                        )}": "
                                        ${$translate.instant(
                                            "DASHBOARD.DASH_INTEG.FIELDS.PH_HEADER"
                                        )}
                                        "${$translate.instant(
                                            "DASHBOARD.DASH_FORM.ACTIONS.ERROR_REQUIRED_FIELD"
                                        )}`
                                    );
                                }
                                if (action.actionData.connection.headers[j].value === '') {
                                    errors.push(
                                        `"${$translate.instant(
                                            "DASHBOARD.DASH_FORM.ACTIONS.ACTION_TITLE"
                                        )} ${i + 1}": "${$translate.instant(
                                            "DASHBOARD.DASH_FORM.ACTIONS.ACTIONS_LIST.WEBHOOK"
                                        )}": "${$translate.instant(
                                            "DASHBOARD.DASH_TASKS.FIELDS.HEADERS"
                                        )}": "
                                        ${$translate.instant(
                                            "DASHBOARD.DASH_INTEG.FIELDS.PH_VALUE"
                                        )}
                                        " ${$translate.instant(
                                            "DASHBOARD.DASH_FORM.ACTIONS.ERROR_REQUIRED_FIELD"
                                        )}`
                                    );
                                }
                            
                            }
                        }
                        break;

                    case "task":
                        if (
                            action.actionData.name === null ||
                            action.actionData.name === ""
                        ) {
                            errors.push(
                                `"${$translate.instant(
                                    "DASHBOARD.DASH_FORM.ACTIONS.ACTION_TITLE"
                                )} ${i + 1}": "${$translate.instant(
                                    "DASHBOARD.DASH_FORM.ACTIONS.ACTIONS_LIST.TASK"
                                )}": "${$translate.instant(
                                    "DASHBOARD.DASH_TASKS.FIELDS.NAME"
                                )}" ${$translate.instant(
                                    "DASHBOARD.DASH_FORM.ACTIONS.ERROR_REQUIRED_FIELD"
                                )}`
                            );
                        }
                        break;
                }
            }

            // If errors, show modal
            if (errors.length > 0) {
                // _this.error =
                //     "Se encontraron los siguientes errores:<br>" +
                //     errors.join("<br>");
                _this.error =
                    $translate.instant(
                        "DASHBOARD.DASH_FORM.ACTIONS.ERROR_ACTIONS_PRE"
                    ) +
                    "<br>" +
                    errors.join("<br>");
                return false;
            }

            // If all fields are valid
            _this.error = "";
            return true;
        };

        this.close = function () {
            let completedForm = this.validateFields();
            // console.log('_this.actions', _this.actions)
            if (completedForm) {
                _this.element.actions = _this.actions;

                // Close all the actions
                for (let i = 0; i < _this.element.actions.length; i++) {
                    _this.element.actions[i].openAction = false;

                    if (_this.element.actions[i].action === "webhook") {
                        // console.log('Entro en for de webhook')
                        if (angular.isArray(_this.element.actions[i].actionData.connection.queryParams)) {
                            let webhookObj = {};
                            _this.element.actions[i].actionData.connection.queryParams.forEach(function(item) {
                                webhookObj[item.key] = item.value;
                            })
                            _this.element.actions[i].actionData.connection.queryParams = webhookObj;
                        }
                        // console.log('convirtio? _this.element.actions[i].actionData.connection.queryParams', _this.element.actions[i].actionData.connection.queryParams);

                        if (angular.isArray(_this.element.actions[i].actionData.connection.headers)) {
                            let webhookObj = {};
                            _this.element.actions[i].actionData.connection.headers.forEach(function(item) {
                                webhookObj[item.key] = item.value;
                            })
                            _this.element.actions[i].actionData.connection.headers = webhookObj;
                        }
                        // console.log('convirtio? _this.element.actions[i].actionData.connection.headers', _this.element.actions[i].actionData.connection.headers);

                    }
                }

                // Old data migration
                if (_this.migrate === true) {
                    _this.element.reportDinamicEmailCopied = true;
                }

                reportConfig = _this.element;

                _this.$close(_this.element);
            } else {
                // Error message.
                this.errorMessage(
                    $translate.instant(
                        "DASHBOARD.DASH_FORM.ACTIONS.ERROR_FIELDS_TITLE"
                    ),
                    _this.error
                );
            }
        };

        this.addAction = function () {
            let action = {
                name: "",
                description: "",
                start: "",
                reportDinamicCondition: [],
                action: "",
                openConditions: false,
                openAction: true,
                inactive: false,
            };

            if (_this.actions) {
                _this.actions.push(action);
            } else {
                _this.actions = [action];
            }
        };

        this.removeAction = function (index) {
            _this.actions.splice(index, 1);
        };

        this.showAction = function (index) {
            if (_this.actions[index].openAction)
                _this.actions[index].openAction = false;
            else _this.actions[index].openAction = true;
        };

        this.toggleInactive = function (index) {
            _this.actions[index].inactive = !_this.actions[index].inactive;
        };

        this.showConditions = function (index) {
            _this.actions[index].openConditions = !_this.actions[index].openConditions;
        };

        // CHANGE ACTION TYPE
        this.changeAction = function (value, index) {
            if (value === "email") {
                _this.actions[index].actionData = {
                    subject: "",
                    body: "",
                    report: "pdf_attachment", // Default pdf
                    options: [], // Array of recipients
                    customFieldEmptyValue: "",
                };
            } else if (value === "task") {
                _this.actions[index].actionData = {
                    name: null,
                    description: null,
                    formId: null,
                    clientId: null,
                    payload: [],
                    date: null,
                    startHour: null,
                    endHour: null,
                    allDay: false,
                    noExpiration: false,
                    repeat: false,
                };
            } else if (value === "webhook") {
                _this.actions[index].actionData = {
                    connection: {
                        method: null, //method: 'GET',
                        url: null,
                        queryParams: {},
                        headers: {},
                        data: null, // Payload JSON
                        responseParams: [],
                    },
                };
            }
        };

        // CONVERT CONDITIONS TO ACTIONS
        // We use 'reportConfig' because 'this.element' is not loaded when trying to access the data.
        // The data from 'Conditions' is processed and stored in 'this.actions'.
        // 'this.element' is solely used for storing the conditions, and upon pressing 'Accept', 'this.actions' is saved into 'this.element'.
        this.convertConditionsToActions = function () {
            const converted = migrateReportDinamicEmail.conditionsToActions(_this.element);
            if (!converted.length) {
                return;
            }

            converted.forEach(function (action) {
                _this.actions.push(action);
            });

            _this.migrate = true;

            _this.errorMessage(
                $translate.instant(
                    "DASHBOARD.DASH_FORM.ACTIONS.ERROR_CONVERT_TITLE"
                ),
                $translate.instant(
                    "DASHBOARD.DASH_FORM.ACTIONS.ERROR_CONVERT_BODY"
                )
            );
        };

        this.errorMessage = function (title, error) {
            dialog.alert({
                title: title,
                body: $sce.trustAsHtml(error),
                close: $translate.instant("DASHBOARD.CLOSE"),
                size: "md",
                html: true,
            });
        };

        // CONVERT OLD CONDITIONS INTO ACTIONS
        _this.convertConditionsToActions();
    },
];
